import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

export default function useCurrencies(admin = false) {
    const { accessToken } = useTokenStore();
    return useQuery(["currencies", admin], async () => {
        const api = await InitApi({ accessToken });
        const response = await api.get(admin ? "/admin/currencies" : "/currencies");
        return response.data?.data?.currencies || [];
    }, { staleTime: 60000, retry: 1 });
}
